import React, { useState, useEffect, useContext } from 'react'
import { Row, Col, Tabs, message, Spin } from 'antd'
import { ShoppingCartOutlined, DollarOutlined, BookOutlined, MenuOutlined, CreditCardOutlined, FormOutlined, OrderedListOutlined } from '@ant-design/icons'
import HeaderPage from '../../components/HeaderPage'
import PosDrawer from './components/PosDrawer'
import SellIndex from './components/sell/SellIndex'
import QuotationIndex from './components/quotation/QuotationIndex'
import ProjectIndex from './components/project/ProjectIndex'
import ReceivableIndex from './components/receivable/ReceivableIndex'
import DepositsIndex from './components/deposits/DepositsIndex'
import SellsListIndex from './components/sellsList/SellsListIndex'
import QuotationListIndex from './components/quotationList/QuotationListIndex'
import ProjectListIndex from './components/projectList/ProjectListIndex'
import PosSrc from './PosSrc'
import DBService from '../../utils/DBService'
import Utils from '../../utils/Utils'
import { Context, useStore } from '../../context'

const { TabPane } = Tabs

function POS() {
  const [state, dispatch] = useContext(Context)
  const { hasPermissions } = useStore(state)
  const [showPosDrawer, setShowPosDrawer] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [status, setStatus] = useState(false)
  const [activeKey, setActiveKey] = useState('10')
  const [storeInfo, setStoreInfo] = useState(null)
  const [turnInfo, setTurnInfo] = useState(null)
  const [loading, setLoading] = useState(true)
  const [quotationData, setQuotationData] = useState({})
  const [projectData, setProjectData] = useState({})
  const [companyId, setCompanyId] = useState('')
  const [symbol, setSymbol] = useState('')
  const [paymentMethods, setPaymentMethods] = useState([])
  const [country, setCountry] = useState('')

  useEffect(() => {
    getStoreTurnByUser()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (storeInfo) {
      fetchData()
    }

    async function fetchData() {
      const store = await PosSrc.getStore(storeInfo.id)
      setSymbol(store.company.currency.symbol)
      setCompanyId(store.company.id)
      setCountry(store.company.country.name)

      const response = await PosSrc.getAllPaymentMethods()
      const paymentMethodCero = response.data.filter( item => item.company_id === 0)
      const paymentMethodCeroTranslate = paymentMethodCero.map(method => ({ id: method.id, description: Utils.translatePaymentMethod(method.name), name: method.name }))
      const paymentMethodCeroTranslateConcat = paymentMethodCeroTranslate.concat(store.company.payment_methods)
      setPaymentMethods(paymentMethodCeroTranslateConcat)
    }
    // eslint-disable-next-line
  }, [storeInfo?.id])  

  const getStoreTurnByUser = async () => {
    const turn = await DBService.getAll('turn')

    if (turn.length) {
      PosSrc.getStoreTurnByUser(turn[0].turn.open_by).then(res => {
        if (!res?.data?.length) {
          DBService.deleteAll('turn')
          DBService.deleteAll('sells')
          DBService.deleteAll('paymentMethods')
          DBService.deleteAll('clients')
          DBService.deleteAll('combos')
          DBService.deleteAll('products')
        }
        isOpenTurn()

      })
    } else {
      isOpenTurn()
    }
  }

  const isOpenTurn = async () => {
    const turn = await DBService.getAll('turn')

    if (turn.length > 0 && turn[0].turn.open_by === state.auth.id
    ) {
      dispatch({
        type: 'TURN OPENED',
        payload: turn[0].turn,
      })
      dispatch({
        type: 'TURN STORE',
        payload: turn[0].store,
      })
      dispatch({
        type: 'TURN INFO',
        payload: turn[0].turnInfo,
      })
      dispatch({
        type: 'TURN CASH',
        payload: turn[0].store.petty_cash_amount,
      })
      setStoreInfo(turn[0].store)
      setTurnInfo(turn[0].turnInfo)
      setDisabled(false)
      setStatus(true)
      setActiveKey('9')
      setLoading(false)
    } else if (turn.length === 0) {
      PosSrc.getStoreTurnByUser(state.auth.id).then(res => {
        const index = res?.data?.length - 1
        if (res?.data[index]?.store_id) {
          PosSrc.getStoreCash(res.data[index].store_id).then(cash => {
            dispatch({
              type: 'TURN OPENED',
              payload: res.data[index],
            })
            dispatch({
              type: 'TURN CASH',
              payload: cash.data[0],
            })
            PosSrc.getTurnById(res.data[index].turn_id).then(turn => {
              dispatch({
                type: 'TURN INFO',
                payload: turn.data[0],
              })
              let turnInfo = [
                {
                  turn: res.data[index],
                  store: cash.data[0],
                  turnInfo: turn.data[0],
                },
              ]
              DBService.add(turnInfo, 'turn')
              setTurnInfo(turn.data[0])
              setStoreInfo(cash.data[0])
              setDisabled(false)
              setStatus(true)
              setActiveKey('9')
              setLoading(false)
              if (turn.data[0] && cash.data[0]) infoStore(cash.data[0], turn.data[0])
            })
          })
        } else {
          DBService.deleteAll('turn')
          DBService.deleteAll('sells')
          DBService.deleteAll('paymentMethods')
          DBService.deleteAll('clients')
          DBService.deleteAll('combos')
          DBService.deleteAll('products')
          setLoading(false)
        }
      })
    }
    setLoading(false)
  }

  const showDrawer = () => {
    setShowPosDrawer(true)
  }

  const setTurn = status => {
    if (status) {
      setDisabled(false)
      setStatus(true)
      setActiveKey('9')
    } else {
      setDisabled(true)
      setStatus(false)
      setActiveKey('10')
    }
    setShowPosDrawer(false)
  }

  const newQuote = () => {
    setQuotationData({})
    setActiveKey('5')
  }

  const newProject = () => {
    setProjectData({})
    setActiveKey('7')
  }

  const infoStore = (store, turn) => {
    setStoreInfo(store)
    setTurnInfo(turn)
    PosSrc.getAllProducts(store.id, turn.id)
      .then(async products => {
        await DBService.add(products.data, 'products')
      })
      .catch(e => {
        console.log(e)
        message.error('No se ha podido cargar los productos.')
      })
    PosSrc.getAllCombos(state.auth.company_id)
      .then(async combos => {
        await DBService.add(combos.data, 'combos')
      })
      .catch(e => {
        console.log(e)
        message.error('No se ha podido cargar los combos.')
      })
    PosSrc.getAllClients()
      .then(async response => {
        await DBService.add(response.data, 'clients')
      })
      .catch(err => {
        console.log(err)
        message.error('Error al cargar los clientes')
      })
    PosSrc.getAllPaymentMethods()
      .then(async response => {
        await DBService.add(response.data, 'paymentMethods')
      })
      .catch(err => {
        console.log(err)
        message.error('Error al cargar los medios de pago')
      })
  }

  return (
    <>
      <Spin spinning={loading}>
        <HeaderPage title={'POS'} pos={true} showDrawer={showDrawer} open={status} store={storeInfo} turnInfo={turnInfo} />
        <PosDrawer
          closable={() => setShowPosDrawer(false)}
          visible={showPosDrawer}
          open={status}
          status={setTurn}
          infoStore={infoStore}
          storeId={storeInfo?.id}
          storeTurnId={turnInfo?.id}
          companyId={companyId}
          symbol={symbol}
          paymentMethods={paymentMethods}
        />
        <Tabs
          id={'tenderoPosTabs'}
          type={'card'}
          tabPosition={'left'}
          activeKey={activeKey}
          onTabClick={key => setActiveKey(key)}
          disabled={disabled}
        >
          {hasPermissions([46]) && (
            <TabPane
              tab={
                <span className="icon-tabs-pos">
                  <ShoppingCartOutlined /> Venta
                </span>
              }
              key="1"
              disabled={disabled}
            >
              <SellIndex
                closeTab={status => setActiveKey(status)}
                store={storeInfo}
                turn={turnInfo}
                quotationData={quotationData}
                projectData={projectData}
                symbol={symbol}
                country={country}
                companyId={companyId}
                paymentMethods={paymentMethods}
              />
            </TabPane>
          )}
          {hasPermissions([57]) && (
            <TabPane
              tab={
                <span className="icon-tabs-pos">
                  <BookOutlined /> Por cobrar
                </span>
              }
              key="2"
              disabled={disabled}
            >
              <ReceivableIndex 
              setQuotationData={setQuotationData}
               setProjectData={setProjectData} 
               activeKey={activeKey} 
               store={storeInfo}
                turn={turnInfo}
                paymentMethods={paymentMethods}
                />
            </TabPane>
          )}
          {hasPermissions([41]) && (
            <TabPane
              tab={
                <span className="icon-tabs-pos">
                  <DollarOutlined /> Depósitos
                </span>
              }
              key="3"
              disabled={disabled}
            >
              <DepositsIndex setQuotationData={setQuotationData} setProjectData={setProjectData} activeKey={activeKey} storeId={storeInfo?.id} storeTurnId={turnInfo?.id} />
            </TabPane>
          )}
          {hasPermissions([45]) && (
            <TabPane
              tab={
                <span className="icon-tabs-pos">
                  <MenuOutlined /> Lista de ventas
                </span>
              }
              key="4"
              disabled={disabled}
            >
              <SellsListIndex activeKey={activeKey} store={storeInfo} />
            </TabPane>
          )}
          {hasPermissions([82]) && state.auth?.company?.allow_quotes === 1 && (
            <TabPane
              tab={
                <span className="icon-tabs-pos">
                  <FormOutlined /> Cotizaciones
                </span>
              }
              key="5"
              disabled={disabled}
            >
              <QuotationIndex
                closeTab={status => setActiveKey(status)}
                store={storeInfo}
                turn={turnInfo}
                quotationData={quotationData}
                projectData={projectData}
                setQuotationData={setQuotationData}
                setProjectData={setProjectData}
              />
            </TabPane>
          )}
          {hasPermissions([81]) && state.auth?.company?.allow_quotes === 1 && (
            <TabPane
              tab={
                <span className="icon-tabs-pos">
                  <OrderedListOutlined /> Lista de cotizaciones
                </span>
              }
              key="6"
              disabled={disabled}
            >
              <QuotationListIndex
                newQuote={newQuote}
                setQuotationData={setQuotationData}
                setProjectData={setProjectData}
                setActiveKey={setActiveKey}
                activeKey={activeKey}
                store={storeInfo}
              />
            </TabPane>
          )}
          {hasPermissions([94]) && state.auth?.company?.allow_projects === 1 && (
            <TabPane
              tab={
                <span className="icon-tabs-pos">
                  <FormOutlined /> Proyectos
                </span>
              }
              key="7"
              disabled={disabled}
            >
              <ProjectIndex
                closeTab={status => setActiveKey(status)}
                store={storeInfo}
                turn={turnInfo}
                quotationData={quotationData}
                projectData={projectData}
                setProjectData={setProjectData}
                setActiveKey={setActiveKey}
              />
            </TabPane>
          )}
          {hasPermissions([93]) && state.auth?.company?.allow_projects === 1 && (
            <TabPane
              tab={
                <span className="icon-tabs-pos">
                  <OrderedListOutlined /> Lista de proyectos
                </span>
              }
              key="8"
              disabled={disabled}
            >
              <ProjectListIndex
                newProject={newProject}
                setProjectData={setProjectData}
                setQuotationData={setQuotationData}
                setActiveKey={setActiveKey}
                activeKey={activeKey}
                store={storeInfo}
              />
            </TabPane>
          )}
          <TabPane key="9" disabled={true}>
            <CreditCardOutlined className={'icon-tab-disabled'} />
            <span className="text-tab-disabled">Selecciona una opción</span>
          </TabPane>
          <TabPane key="10" disabled={true}>
            <Row gutter={16} className={'section-space-field'}>
              <Col span={24} className={'empty-section-container'}>
                <div className={'empty-section'}>
                  <span className={'empty-section-message'}>Por favor inicia un turno para empezar a vender</span>
                </div>
              </Col>
            </Row>
          </TabPane>
        </Tabs>
      </Spin>
    </>
  )
}

export default POS
